import {Download} from "./Download";
import {Local} from "../../../domain/Local";
import LocalDataSource from "../../../data-sources/LocalDataSource";
import {Bioma} from "../../../domain/Bioma";
import {In} from "typeorm";

export class DownloadLocal extends Download<Local> {

  override async transformBeforeSave(lista: Local[]): Promise<Local[]> {
    const repo = LocalDataSource.getRepository(Bioma)
    for (let l of lista) {
      if (l.biomas != undefined && l.biomas.length > 0) {
        l.biomas = await repo.findBy({id: In(l.biomas)})
      }
    }
    return lista
  }
}
